import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Zap, Users, Award, CheckCircle } from "lucide-react";
// import ImageCarousel from '../components/ImageCarousel';
// import FileOrderModal from "./FileOrderModal";

const HomePage = () => {
  const [showOffer, setShowOffer] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setShowOffer(true), 600);
    return () => clearTimeout(t);
  }, []);

  const features = [
    {
      icon: <Zap className="w-8 h-8 text-black-400" />,
      title: "Fast Digital Solutions",
      description:
        "Full Arch Zirconia in just three appointments with advanced digital workflows.",
    },
    {
      icon: <Award className="w-8 h-8 text-black-400" />,
      title: "Premium Quality",
      description:
        "High-quality restoration with precision and care using cutting-edge technology.",
    },
    {
      icon: <Users className="w-8 h-8 text-black-400" />,
      title: "Expert Craftsmanship",
      description:
        "Trusted partner for dental professionals delivering confident smiles every day.",
    },
  ];

  const pricingPlans = [
    {
      name: "The Ace Package - Zirconia",
      price: "$1,550 Starting",
      period: "From day of surgery to final zirconia delivery",
      description:
        "The Ace Package – Zirconia provides a complete full-arch solution from start to finish. This package includes same-day provisional design, multiple adjustment options, and a premium final zirconia restoration built for long-term strength, function, and aesthetics.",
      features: [
        "Same-day temporary design",
        "Up to 3 design adjustments",
        "Final Zirconia Restoration",
        "Premium, durable full-arch restoration",
      ],
      popular: false,
    },
    {
      name: "Express All-on-X Design",
      price: "$300",
      period: "Same-day digital design for All-on-X cases",
      description:
        "Our Express All-on-X Design service delivers rapid, precise prosthetic designs using a fully digital workflow. Ideal for surgeons and labs needing same-day full-arch design support with accuracy and reliability.",
      features: ["Same Day All-On-X Design", "Fast Precise digital workflow"],
      popular: true,
    },
    {
      name: "Ace On-Site Tech - Photogrammetry",
      price: "$500 Starting ",
      description:
        "Our On-Site photogrammetry service ensures highly accurate implant capture for full-arch cases. Achieve precise, same-day results with faster turnaround and improved patient comfort.",
      features: [
        "On-Site chairside scanning ",
        "Advanced photogrammetry technology",
        "Ideal for full-arch implant cases",
        "Nationwide availability (location based pricing)",
      ],
      popular: false,
    },
  ];

  const carouselImages = ["/Images/IMG_4019homepage.webp"];

  return (
    <div className="min-h-screen">
      {/* ✅ POPUP MODAL ON TOP OF HOMEPAGE */}
      {/* <FileOrderModal open={showOffer} onClose={() => setShowOffer(false)} /> */}

      {/* Hero Section */}
      {/* <section ...> ... </section> */}

      <section className=" bg-black pt-20  pb-28  overflow-hidden">
        <div className="absolute inset-0   "></div>
        <div className="absolute inset-0   "></div>

        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6     lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div className="text-center lg:text-left">
              <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight mt-32">
                <span className="block text-white">Quality.</span>
                <span className="block text-white">Precision.</span>
                <span className="block text-white ">Consistency.</span>
              </h1>

              <p className="text-xl text-white mb-8 leading-relaxed max-w-2xl">
               Ace Dental Lab is a reliable partner in full-arch restorations,
                utilizing a fully digital workflow and the latest advancements in dental technology.
                 We combine speed with uncompromising quality,
                  ensuring every case is delivered with care,
                   and results you and your patients deserve.
              </p>

              <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
                <Link
                  to="/contact"
                  className="inline-flex items-center  bg-white  text-black px-8 py-4 rounded-lg font-medium "
                >
                  Send Case
                  <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
                </Link>

                <Link
                  to="/product"
                  className="inline-flex items-center   bg-warning-subtle   border-2 border-white text-white px-8 py-4 rounded-lg font-medium hover:bg-white-400 hover:text-white transition-all duration-200"
                >
                  View Products
                </Link>
              </div>
            </div>

            <div className="lg:pl-8">
              <video className="bg-transparent" autoPlay loop muted playsInline>
                <source
                  src="/Images/AnimationHomePage2.mp4"
                  type="video/mp4"
                />
              </video>
               {/* <img
                src="/Images/Homepage Picture.png"
                alt="Ace Dental Animation"
               
                className="h-auto w-full sm:max-w-sm md:max-w-md lg:max-w-sm mix-blend-multiply mx-auto mt-4"
                className="h-auto w-full sm:max-w-md md:max-w-lg lg:max-w-2xl mix-blend-multiply mx-auto mt-36"
              /> */}
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Us Section */}
       {/* style={{ backgroundImage: "url('/Images/bg blackedit.jpg')" }} */}
      <section className="bg-black pt-40">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4">
              Why Choose Ace Dental Lab?
            </h2>
            <p className="text-lg text-white max-w-3xl mx-auto leading-relaxed">
             We combine advanced digital workflows, premium materials,
              and expert craftsmanship to deliver restorations
               that exceed expectations in strength, beauty, and accuracy.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-12">
            <div className="p-8 bg-white rounded-2xl shadow-md border border-gray-200 hover:shadow-xl transition">
              <h3 className="text-xl font-semibold text-gray-800 mb-4">
                State-of-the-Art Technology
              </h3>
              <p className="text-gray-600 leading-relaxed">
                Using the latest in 3D scanning, CAD/CAM, and zirconia milling
                technology, we ensure precise, consistent, and natural-looking
                restorations.
              </p>
            </div>

            <div className="p-8 bg-white rounded-2xl shadow-md border border-gray-200 hover:shadow-xl transition">
              <h3 className="text-xl font-semibold text-gray-800 mb-4">
                Fast Turnaround
              </h3>
              <p className="text-gray-600 leading-relaxed">
                We deliver fast, reliable results, including same-day surgery designs and full-arch solutions, when cases are scheduled, in as little as three appointments.
              </p>
            </div>

            <div className="p-8 bg-white rounded-2xl shadow-md border border-gray-200 hover:shadow-xl transition">
              <h3 className="text-xl font-semibold text-gray-800 mb-4">
                Premium Materials
              </h3>
              <p className="text-gray-600 leading-relaxed">
                We use only high-quality zirconia, titanium substructures, and
                biocompatible materials for long-lasting strength and comfort.
              </p>
            </div>
          </div>

          <div className="grid md:grid-cols-3 gap-12 mt-12">
            <div className="p-8 bg-white rounded-2xl shadow-md border border-gray-200 hover:shadow-xl transition">
              <h3 className="text-xl font-semibold text-gray-800 mb-4">
                Expert Technicians
              </h3>
              <p className="text-gray-600 leading-relaxed">
                Our skilled team ensures every design reflects natural anatomy,
                aesthetics, and functional precision.
              </p>
            </div>

            <div className="p-8 bg-white rounded-2xl shadow-md border border-gray-200 hover:shadow-xl transition">
              <h3 className="text-xl font-semibold text-gray-800 mb-4">
                100% Custom Restoration
              </h3>
              <p className="text-gray-600 leading-relaxed">
                Each smile is engineered from scratch—no templates, no
                compromises. Fully customized for every patient.
              </p>
            </div>

            <div className="p-8 bg-white rounded-2xl shadow-md border border-gray-200 hover:shadow-xl transition">
              <h3 className="text-xl font-semibold text-gray-800 mb-4">
                Clinician Support
              </h3>
              <p className="text-gray-600 leading-relaxed">
                We collaborate closely with dentists and surgeons, offering
                chairside support and continuous communication.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Commitment Section */}
      <section className="py-12 bg-black  border-black-200">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-14">
            <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4">
              Our Commitment to Excellence
            </h2>
            <p className="text-lg text-white max-w-3xl mx-auto leading-relaxed">
              At Ace Dental Lab, quality isn’t an option—it’s our promise. Every
              case, every design, and every restoration is crafted with
              precision, care, and a deep understanding of patient needs.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-10">
            <div className="p-8 rounded-2xl bg-slate-50 border border-gray-200 shadow-sm hover:shadow-md transition-all duration-200">
              <h3 className="text-xl font-semibold text-gray-900 mb-3">
                Precision in Every Detail
              </h3>
              <p className="text-gray-700 leading-relaxed">
                From digital planning to final fabrication, every step of your
                case is handled with the highest level of attention and
                accuracy.
              </p>
            </div>

            <div className="p-8 rounded-2xl bg-slate-50 border border-gray-200 shadow-sm hover:shadow-md transition-all duration-200">
              <h3 className="text-xl font-semibold text-gray-900 mb-3">
                Designed for Long-Term Success
              </h3>
              <p className="text-gray-700 leading-relaxed">
                Our restorations are engineered for durability, aesthetics, and
                long-term patient comfort using the best materials available.
              </p>
            </div>

            <div className="p-8 rounded-2xl bg-slate-50 border border-gray-200 shadow-sm hover:shadow-md transition-all duration-200">
              <h3 className="text-xl font-semibold text-gray-900 mb-3">
                Partnership You Can Trust
              </h3>
              <p className="text-gray-700 leading-relaxed">
                We work closely with every clinician, ensuring smooth
                communication and dependable results from start to finish.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-black">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-6">
            We are here to elevate your full-arch case today.</h2>
          <h3 className="text-2xl font-semibold text-white mb-8">
            We combine innovation, precision, and personalized care.
          </h3>
        </div>
      </section>
    </div>
  );
};

export default HomePage;
